function idsEqual(a, b) {
  if (a === null || a === undefined || b === null || b === undefined) return false;
  return String(a) === String(b);
}

function isActive(item) {
  return Number(item?.is_active) === 1;
}

function orgMatches(item, orgId) {
  return item?.org_id == null || idsEqual(item.org_id, orgId);
}

function matchForElement(list, { courseId, elementId, orgId }) {
  const matches = (Array.isArray(list) ? list : []).filter((item) =>
    idsEqual(item.course_id, courseId)
    && idsEqual(item.element_id, elementId)
    && isActive(item)
    && orgMatches(item, orgId),
  );

  return matches.find((item) => idsEqual(item.org_id, orgId)) ?? matches[0] ?? null;
}

export function matchProctorConfig(list, { courseId, elementId, resolvedElementId, orgId }) {
  if (resolvedElementId && !idsEqual(resolvedElementId, elementId)) {
    const resolvedMatch = matchForElement(list, { courseId, elementId: resolvedElementId, orgId });
    if (resolvedMatch) return resolvedMatch;
  }
  return matchForElement(list, { courseId, elementId, orgId });
}

export function isDesktopDevice(userAgent = '') {
  const ua = String(userAgent).toLowerCase();
  return !/android|iphone|ipad|ipod|mobile/i.test(ua);
}

export function getProctorElementIds(list) {
  return (Array.isArray(list) ? list : [])
    .filter(isActive)
    .map((item) => item.element_id)
    .filter((id) => id !== null && id !== undefined);
}
